var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProducerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 42 52"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#producer-icon_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "producer-icon_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 45.41a.95.95 0 0 1-.665-.27C19.708 44.528 5 30.03 5 19.644c-.02-2.06.379-4.103 1.176-6.01A15.5 15.5 0 0 1 9.64 8.538a15.9 15.9 0 0 1 5.212-3.388C16.803 4.371 18.893 3.98 21 4c2.107-.02 4.197.371 6.147 1.15 1.95.78 3.722 1.931 5.212 3.388a15.5 15.5 0 0 1 3.464 5.096A15.2 15.2 0 0 1 37 19.644C37 30.03 22.292 44.528 21.665 45.14a.95.95 0 0 1-.665.27"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#40B481",
  stroke: "#fff",
  strokeWidth: 2.909,
  d: "M21 45.41a.95.95 0 0 1-.665-.27C19.708 44.528 5 30.03 5 19.644c-.02-2.06.379-4.103 1.176-6.01A15.5 15.5 0 0 1 9.64 8.538a15.9 15.9 0 0 1 5.212-3.388C16.803 4.371 18.893 3.98 21 4c2.107-.02 4.197.371 6.147 1.15 1.95.78 3.722 1.931 5.212 3.388a15.5 15.5 0 0 1 3.464 5.096A15.2 15.2 0 0 1 37 19.644C37 30.03 22.292 44.528 21.665 45.14a.95.95 0 0 1-.665.27Z",
  mask: "url(#producer-icon_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m28.484 19.453-1.255-3.137a.63.63 0 0 0-.303-.329l-3.764-1.882a.63.63 0 0 0-.562 0l-3.764 1.882a.63.63 0 0 0-.302.328l-1.255 3.137-.044.232v6.275c0 .346.28.628.627.628h1.882a.63.63 0 0 0 .628-.628v-3.137c0-.346.28-.627.627-.627h3.765c.346 0 .627.28.627.627v3.137c0 .346.281.628.627.628h1.883a.63.63 0 0 0 .627-.628v-6.274zm-4.348-.081c0 .173-.14.314-.314.314H21.94a.314.314 0 0 1-.314-.314v-.874c0-.625.428-1.205 1.044-1.304a1.256 1.256 0 0 1 1.466 1.238zM17.369 15.85l-.53 1.326H13.47v-2.51c0-1.834 1.574-3.3 3.445-3.122 1.415.135 2.501 1.255 2.765 2.618l-1.404.703a1.88 1.88 0 0 0-.907.986M15.989 19.518l-.01.167v2.51H13.47v-3.764h2.867l-.267.667zM15.98 23.45v2.51c0 .22.045.43.115.627h-1.997a.63.63 0 0 1-.628-.627v-2.51z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "producer-icon_svg__a",
  width: 42,
  height: 51.41,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_39714"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1_39714",
  result: "effect2_dropShadow_1_39714"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 2,
  result: "effect3_dropShadow_1_39714"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_dropShadow_1_39714",
  result: "effect3_dropShadow_1_39714"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_39714",
  result: "shape"
})))));
export { SvgProducerIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/producer-icon.7aaf8db4.svg";